// import React, { useState, useEffect } from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   Button,
//   Table,
//   Row,
//   Col,
// } from "reactstrap";
// import { postMethod } from "../../../../_services/_postMethod";
// import { API_BASE_URL } from "../../../../_services/constant";

// const ProductDetails = ({ data }) => {
//   const [details, setDetails] = useState([]);
//   const [showDetails, setShowDetails] = useState(false);
//   const [selectedColor, setSelectedColor] = useState("");

//   const toggle = () => setShowDetails(!showDetails);

//   const getProductDetails = async () => {
//     try {
//       const res = await postMethod("api/masters/product_details", {
//         product_code: data,
//       });

//       if (res?.data) {
//         const productDetails = res.data.details || res.data;
//         setDetails(productDetails);
//         if (productDetails.length > 0) {
//           setSelectedColor(productDetails[0].color);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching product details:", error);
//     }
//   };

//   useEffect(() => {
//     if (showDetails && data) {
//       getProductDetails();
//     }
//   }, [showDetails, data]);

//   const handleColorClick = (color) => setSelectedColor(color);

//   // Extract unique values
//   const uniqueColors = [...new Set(details.map((item) => item.color))];

//   // Unique Brand + Address combination
//   const uniqueBranches = [
//     ...new Map(
//       details.map((item) => [
//         item.brand_name + " | " + item.address,
//         { brand: item.brand_name, address: item.address },
//       ])
//     ).values(),
//   ];

//   const uniqueSizes = [...new Set(details.map((item) => item.size_length))];

//   // Functions to get table values
//   const getQtyBySizeAndBranch = (size, branch) => {
//     const match = details.find(
//       (d) =>
//         d.size_length === size &&
//         d.brand_name === branch.brand &&
//         d.address === branch.address &&
//         d.color === selectedColor
//     );
//     return match ? match.total_stock_qty : "-";
//   };

//   const getTotalByBranch = (branch) => {
//     return details
//       .filter(
//         (d) =>
//           d.brand_name === branch.brand &&
//           d.address === branch.address &&
//           d.color === selectedColor
//       )
//       .reduce((sum, d) => sum + (d.total_stock_qty || 0), 0);
//   };

//   const getGrandTotal = () => {
//     return details
//       .filter((d) => d.color === selectedColor)
//       .reduce((sum, d) => sum + (d.total_stock_qty || 0), 0);
//   };

//   return (
//     <>
//       <Button color="info" size="sm" onClick={toggle}>
//         <i className="fa fa-info-circle"></i> Details
//       </Button>

//       <Modal isOpen={showDetails} size="lg" backdrop="static" centered>
//         <ModalHeader toggle={toggle}>
//           <Row className="w-100">
//             <Col sm="6">Product Details</Col>
//             <Col sm="6">
//               <i
//                 className="fa fa-close pull-right pointerShow"
//                 onClick={toggle}
//               ></i>
//             </Col>
//           </Row>
//         </ModalHeader>

//         <ModalBody>
//           {details.length > 0 && (
//             <>
//               <Row>
//                 {/* Left Side – Product Info */}
//                 <Col md={8}>
//                   <h5>{details[0].product_name}</h5>
//                   <p className="text-muted">{details[0].product_code}</p>

//                   {/* Example Static Pricing */}
//                 <h6>
//   <span style={{ color: "#007bff" }}>
//     ₹{Number(details[0].discounted_price).toFixed(2)}
//   </span>{" "}
//   <del className="text-danger">
//     ₹{Number(details[0].price).toFixed(2)}
//   </del>
// </h6>
//                   <Table bordered size="sm" className="mt-3">
//                     <tbody>
//                       <tr>
//                         <td><b>Brand</b></td>
//                         <td>{details[0].brand_name}</td>
//                       </tr>
//                       <tr>
//                         <td><b>Fabric</b></td>
//                         <td>{details[0].material}</td>
//                       </tr>
//                       <tr>
//                         <td><b>Total Qty</b></td>
//                         <td>{getGrandTotal()}</td>
//                       </tr>
//                     </tbody>
//                   </Table>
//                 </Col>

//                 {/* Right Side – Image */}
//                <Col md={4} className="text-center">
//   {details[0]?.image_path ? (
//     <img
//       src={
//         details[0].isImageUrl === true
//           ? details[0].image_path            
//           : `${API_BASE_URL}Images/${details[0].image_path}` 
//       }
//       alt="Product"
//       style={{
//         maxWidth: "100%",
//         borderRadius: "10px",
//         border: "1px solid #ddd",
//       }}
//     />
//   ) : (
//     <p>No Image</p>
//   )}
// </Col>

//               </Row>

//               {/* Color Buttons */}
//               <Row className="mt-4">
//                 <Col>
//                   {uniqueColors.map((color, idx) => (
//                     <Button
//                       key={idx}
//                       color={color === selectedColor ? "primary" : "secondary"}
//                       outline={color !== selectedColor}
//                       size="sm"
//                       className="me-2 mb-2"
//                       onClick={() => handleColorClick(color)}
//                     >
//                       {color}
//                     </Button>
//                   ))}
//                 </Col>
//               </Row>

//               {/* Stock Table */}
//               <Table bordered responsive className="mt-4 text-center">
//                 <thead className="bg-danger text-white">
//                   <tr>
//                     <th>Size</th>

//                     {uniqueBranches.map((br, idx) => (
//                       <th key={idx}>
//                         {br.brand}
//                         <br />
//                         <small className="text-warning">{br.address}</small>
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {uniqueSizes.map((size, i) => (
//                     <tr key={i}>
//                       <td><b>{size}</b></td>

//                       {uniqueBranches.map((br, j) => (
//                         <td key={j}>{getQtyBySizeAndBranch(size, br)}</td>
//                       ))}
//                     </tr>
//                   ))}

//                   <tr className="fw-bold bg-light">
//                     <td>Total</td>

//                     {uniqueBranches.map((br, i) => (
//                       <td key={i}>{getTotalByBranch(br)}</td>
//                     ))}
//                   </tr>
//                 </tbody>
//               </Table>
//             </>
//           )}
//         </ModalBody>
//       </Modal>
//     </>
//   );
// };

// export default ProductDetails;



import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Row,
  Col,
} from "reactstrap";
import { Tooltip } from "@material-ui/core";
import { postMethod } from "../../../../_services/_postMethod";
import { API_BASE_URL } from "../../../../_services/constant";

const ProductDetails = ({ data }) => {
  const [details, setDetails] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");

  const toggle = () => setShowDetails(!showDetails);

  const getProductDetails = async () => {
    try {
      const res = await postMethod("api/masters/product_details", {
        product_code: data,
      });

      if (res?.data) {
        const productDetails = res.data.details || res.data;
        setDetails(productDetails);
        if (productDetails.length > 0) {
          setSelectedColor(productDetails[0].color);
        }
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  useEffect(() => {
    if (showDetails && data) {
      getProductDetails();
    }
  }, [showDetails, data]);

  const handleColorClick = (color) => setSelectedColor(color);

  // Extract unique values
  const uniqueColors = [...new Set(details.map((item) => item.color))];

  // Unique Brand + Address combination
  const uniqueBranches = [
    ...new Map(
      details.map((item) => [
        item.brand_name + " | " + item.address,
        { brand: item.brand_name, address: item.address },
      ])
    ).values(),
  ];

  const uniqueSizes = [...new Set(details.map((item) => item.size_length))];

  // Functions to get table values
  const getQtyBySizeAndBranch = (size, branch) => {
    const match = details.find(
      (d) =>
        d.size_length === size &&
        d.brand_name === branch.brand &&
        d.address === branch.address &&
        d.color === selectedColor
    );
    return match ? match.branch_balance_qty : "-";
  };

  const getTotalByBranch = (branch) => {
    return details
      .filter(
        (d) =>
          d.brand_name === branch.brand &&
          d.address === branch.address &&
          d.color === selectedColor
      )
      .reduce((sum, d) => sum + (d.branch_balance_qty || 0), 0);
  };

  const getGrandTotal = () => {
    return details
      .filter((d) => d.color === selectedColor)
      .reduce((sum, d) => sum + (d.branch_balance_qty || 0), 0);
  };

  // 🔹 Get product info for selected color
  const selectedColorProduct =
    details.find((d) => d.color === selectedColor) || details[0];

  const capitalizeColor = (color) => {
    if (!color) return "";
    return String(color)
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <>
      <Button color="info" size="sm" onClick={toggle}>
        <i className="fa fa-info-circle"></i> Details
      </Button>

      <Modal isOpen={showDetails} size="lg" backdrop="static" zIndex="9999999" centered>
        <ModalHeader toggle={toggle}>
          <Row className="w-100">
            <Col sm="6">Product Details</Col>
            <Col sm="6">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={toggle}
              ></i>
            </Col>
          </Row>
        </ModalHeader>

        <ModalBody>
          {details.length > 0 && (
            <>
              <Row>
                {/* Left Side – Product Info */}
                <Col md={8}>
                  <h5>{selectedColorProduct.product_name}</h5>
                  <p className="text-muted">{selectedColorProduct.productcode}</p>

                  {/* Price updated based on selected color */}
                  <h6>
                    {selectedColorProduct?.discounted_price > 0 ? (
                      <>
                        <span style={{ color: "#007bff" }}>
                          ₹{Number(selectedColorProduct.discounted_price).toFixed(2)}
                        </span>{" "}
                        <del className="text-danger">
                          ₹{Number(selectedColorProduct?.price || 0).toFixed(2)}
                        </del>
                      </>
                    ) : (
                      <span style={{ color: "#007bff" }}>
                        ₹{Number(selectedColorProduct?.price || 0).toFixed(2)}
                      </span>
                    )}
                  </h6>

                  <Table bordered size="sm" className="mt-3">
                    <tbody>
                      <tr>
                        <td><b>Brand</b></td>
                        <td>{selectedColorProduct.brand_name}</td>
                      </tr>
                      <tr>
                        <td><b>Fabric</b></td>
                        <td>{selectedColorProduct.material}</td>
                      </tr>
                      <tr>
                        <td><b>Size</b></td>
                        <td>{selectedColorProduct.size_length}</td>
                      </tr>
                      <tr>
                        <td><b>Total Qty</b></td>
                        <td>{getGrandTotal()}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>

                {/* Right Side – Image */}
                <Col md={4} className="text-center d-flex align-items-center justify-content-center">
                  {selectedColorProduct?.image_path ? (
                    <img
                      src={
                        selectedColorProduct.isImageUrl === true
                          ? selectedColorProduct.image_path
                          : `${API_BASE_URL}Images/${selectedColorProduct.image_path}`
                      }
                      alt="Product"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                      }}
                    />
                  ) : (
                    <p>No Image</p>
                  )}
                </Col>
              </Row>

              {/* Color Buttons */}
              <Row className="mt-4">
                <Col>
                  {uniqueColors.map((color, idx) => (
                    <Button
                      key={idx}
                      color={color === selectedColor ? "primary" : "secondary"}
                      outline={color !== selectedColor}
                      size="sm"
                      className="me-2 mb-2 mr-2"
                      onClick={() => handleColorClick(color)}
                    >
                      {capitalizeColor(color)}
                    </Button>
                  ))}
                </Col>
              </Row>

              {/* Stock Table */}
              <Table bordered responsive className="mt-4 text-center">
                <thead className="bg-danger text-white">
                  <tr>
                    <th>Size</th>
                    {uniqueBranches.map((br, idx) => (
                      <th key={idx} style={{ minWidth: "120px", maxWidth: "160px", verticalAlign: "middle", cursor: "pointer" }} title={`${br.brand} (${br.address})`}>
                        <Tooltip
                          title={
                            <span style={{ fontSize: "13px", fontWeight: "500", padding: "2px" }}>
                              {br.brand} ({br.address})
                            </span>
                          }
                          arrow
                          placement="top"
                          PopperProps={{ style: { zIndex: 99999999 } }}
                        >
                          <div>
                            <div
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                                fontSize: "14px",
                              }}
                            >
                              {br.brand}
                            </div>
                            <span
                              className="text-warning"
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontSize: "12px",
                              }}
                            >
                              {br.address}
                            </span>
                          </div>
                        </Tooltip>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {uniqueSizes.map((size, i) => (
                    <tr key={i}>
                      <td><b>{size}</b></td>
                      {uniqueBranches.map((br, j) => (
                        <td key={j}>{getQtyBySizeAndBranch(size, br)}</td>
                      ))}
                    </tr>
                  ))}

                  <tr className="fw-bold bg-light">
                    <td>Total</td>
                    {uniqueBranches.map((br, i) => (
                      <td key={i}>{getTotalByBranch(br)}</td>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default ProductDetails;
